import {
  FieldTextInput,
  FieldTextArea,
  FieldTimeInput,
  FieldDatePicker,
} from '@/components/form/fields';
import { FormSubmitButton } from '@/components/form/formSubmitButton';
import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextInput: FieldTextInput,
    TextArea: FieldTextArea,
    TimeInput: FieldTimeInput,
    DatePicker: FieldDatePicker,
  },
  formComponents: {
    SubmitButton: FormSubmitButton,
  },
});
